import React from 'react';
import PropTypes from 'prop-types';
import { unflatten } from 'flat';
import moment from 'moment';

import Form from '../../Form';
import DateRangeInput from '../../DateRangeInput';
import DateInput from '../../DateInput';
import { Popup } from 'src/components/Popup/Popup';
import Loading from '../../Loading';
import UniverseAware from '../../../utils/UniverseAware';
import { getTranslationFor } from 'src/locale/lang';


@UniverseAware
class ReportsFilter extends Form {
    static propTypes = {
        ...Form.propTypes,

        state: PropTypes.string,
        universePrefix: PropTypes.string,
        onClear: PropTypes.func.isRequired,
        onGetReportsRequest: PropTypes.func.isRequired,
        onRunReportRequest: PropTypes.func.isRequired
    };

    static defaultProps = {
        ...Form.defaultProps,

        markValid: false
    };

    static fieldsValidation = {
        type: [ 'required' ],
        accountId: [ (value, data) => {
            if (Form.empty(value) && data.type === 'statements') {
                return getTranslationFor('ERROR_REQUIRED_FIELD');
            } else {
                return null;
            }
        } ]
    };

    constructor(props, context) {
        super(props, context);

        this.state.displayReportParamsPopup = false;
        this.state.data.dateRange = {
            startDate: moment().startOf('day').subtract(7, 'days'),
            endDate: moment().startOf('day')
        };
        this.state.data['params.lastBetAfter'] = moment().startOf('day').format('YYYY-MM-DD');
        // Error 500 (timeout). Temporary change: (related task: SP-3222)
        // this.state.data['params.lastBetAfter'] = moment().subtract(1, 'year').format('YYYY-MM-DD');
        this.state.data['includeLastDay'] = false;
    }

    componentWillUnmount() {
        this.props.onClear();
    }

    onSubmit(e) {
        e.preventDefault();

        const { type, accountId } = this.state.data;

        if (this.isValid()) {
            this.props.onGetReportsRequest(type, accountId);
        }
    }

    showReportParamsForm() {
        if (!this.isValid()) {
            return;
        }

        this.setState({ displayReportParamsPopup: true });
    }

    hideReportParamsForm() {
        this.setState({ displayReportParamsPopup: false });
    }

    onRunReport() {
        const { type, accountId, dateRange, includeLastDay } = this.state.data;
        const params = unflatten(this.state.data).params || {};

        if (!this.isValid()) {
            return;
        }
        if ( type === 'freebets') {
            const { GrantedRange = dateRange, ClaimedRange = dateRange,
                includeLastDay_Claimed = includeLastDay, includeLastDay_Garanted = includeLastDay } = this.state.data;

            params.grantStartDate = GrantedRange.startDate && moment(GrantedRange.startDate);
            params.grantEndDate = GrantedRange.endDate && ( includeLastDay_Garanted ? moment(GrantedRange.endDate).add(1, 'days') : moment(GrantedRange.endDate));

            params.claimStartDate = ClaimedRange.startDate && moment(ClaimedRange.startDate);
            params.claimEndDate = ClaimedRange.endDate && ( includeLastDay_Claimed ? moment(ClaimedRange.endDate).add(1, 'days') : moment(ClaimedRange.endDate));
            delete params.lastBetAfter;

        } else if (dateRange) {
            params.startDate = dateRange.startDate && moment(dateRange.startDate);
            params.endDate = dateRange.endDate && ( includeLastDay ? moment(dateRange.endDate).add(1, 'days') : moment(dateRange.endDate));
        }

        if ( type.includes( 'incomeaccess-' ) ) {
            params.startDate = moment( params.startDate ).format( 'YYYY-MM-DD' );
            params.endDate = moment( params.endDate ).format( 'YYYY-MM-DD' );
        }

        if ( type.includes( 'affiliate-' ) ) {
            params.startDate = moment( params.startDate ).format( 'YYYY-MM-DD' );
            params.endDate = moment( params.endDate ).format( 'YYYY-MM-DD' );
        }

        this.props.onRunReportRequest(type, accountId, params);
        this.setState({ displayReportParamsPopup: false });
    }

    onReload() {
        const { type, accountId } = this.state.data;

        this.props.onClear();
        this.props.onGetReportsRequest(type, accountId);
    }

    getReportParamsFields() {
        const { type } = this.state.data;
        const restrainedRangeReports = [ 'client-openings', 'statements', 'mobile-returns', 'in-play-returns',
            'gross-gambling-yield', 'ggy-jurisdiction', 'betting-levy', 'payments', 'bet-referral',
            'incomeaccess-accounts', 'incomeaccess-sales', 'affiliate-accounts', 'affiliate-sales', 'void-bets', 'play-break', 'isonis', 'casino-report'];
        const unRestrainedRangeReports = [ 'card-expiration', 'birthday-list', 'bonuses', 'credit-debit' ];
        const filteredWithDate = {
            'winners-and-losers': { label: 'Limit the list', parameter: 'params.limit' },
            'trading': { label: 'Significant amount', parameter: 'params.significantAmount' }
        };

        if (restrainedRangeReports.indexOf(type) >= 0) {
            return (
                <div className='formData'>
                    {
                        this.getField(
                            <DateRangeInput
                                { ...this.getFieldParameters('dateRange') }
                            />
                        )
                    }
                    {
                        this.getCheckbox('includeLastDay', 'Include Last Day')
                    }
                </div>
            );
        }

        if (unRestrainedRangeReports.indexOf(type) >= 0) {
            return (
                <div className='formData'>
                    {
                        this.getField(
                            <DateRangeInput
                                maxDate={ null }
                                { ...this.getFieldParameters('dateRange') }
                            />
                        )
                    }
                    {
                        this.getCheckbox('includeLastDay', 'Include Last Day')
                    }
                </div>
            );
        }

        if (type === 'active-accounts') {
            return (
                <div>
                    {
                        this.getField(
                            <DateInput
                                label='Last bet after'
                                { ...this.getFieldParameters('params.lastBetAfter') }
                            />
                        )
                    }
                    {
                        this.getCheckbox('includeLastDay', 'Include Last Day')
                    }
                </div>
            );
        } else if (type === 'freebets') {
            return (
                <div className='formData'>
                    {
                        this.getField(
                            <DateRangeInput
                                maxDate={ null }
                                startLabel='Granted start date'
                                endLabel='Granted end date'
                                { ...this.getFieldParameters('GrantedRange') }
                            />
                        )
                    }
                    {
                        this.getCheckbox('includeLastDay_Garanted', 'Include Last Day')
                    }
                    {
                        this.getField(
                            <DateRangeInput
                                maxDate={ null }
                                startLabel='Claimed start date'
                                endLabel='Claimed end date'
                                { ...this.getFieldParameters('ClaimedRange') }
                            />
                        )
                    }
                    {
                        this.getCheckbox('includeLastDay_Claimed', 'Include Last Day')
                    }
                </div>
            );
        }

        if (Object.keys(filteredWithDate).indexOf(type) >= 0) {
            return (
                <div className='formData'>
                    {
                        this.getField(
                            <DateRangeInput
                                { ...this.getFieldParameters('dateRange') }
                            />
                        )
                    }

                    {
                        this.getField(
                            <input
                                label={ filteredWithDate[type].label }
                                { ...this.getFieldParameters(filteredWithDate[type].parameter) }
                            />
                        )
                    }
                    {
                        this.getCheckbox('includeLastDay', 'Include Last Day')
                    }
                </div>
            );
        }
    }

    renderForm() {
        const paramsFields = this.getReportParamsFields();
        const runReportButtonAction = ( paramsFields ? this.showReportParamsForm.bind(this) : this.onRunReport.bind(this));
        let accountIdField = null;
        const { universePrefix } = this.props;
        if (this.state.data.type === 'statements') {
            accountIdField =
                (<div className='form-group'>
                    <div className='form-prefix-group'>
                        { universePrefix ? <span className='form-prefix-group__label'>{ universePrefix }</span> : void 0 }
                        {
                            this.getField(
                                <input
                                    label='Account ID'
                                    { ...this.getFieldParameters( 'accountId' ) }
                                />
                            )
                        }
                    </div>
                </div>);
        }

        return (
            <div className='reports-filter'>
                <div className='reports-filter-filter'>
                    {
                        this.getField(
                            <select
                                label='Report Type'
                                { ...this.getFieldParameters('type') }
                            >
                                <option />
                                <option value='active-accounts'>Active Accounts</option>
                                <option value='betting-levy'>Betting Levy</option>
                                <option value='bet-referral'>Bet Referral</option>
                                <option value='birthday-list'>Birthday List</option>
                                <option value='bonuses'>Bonuses</option>
                                <option value='casino-report'>Casino Report</option>
                                <option value='client-openings'>Client Openings</option>
                                <option value='freebets'>Freebets</option>
                                <option value='ggy-jurisdiction'>GGY based on Jurisdiction</option>
                                <option value='gross-gambling-yield'>Gross Gambling Yield</option>
                                <option value='in-play-returns'>In Play Betting Returns</option>
                                <option value='mobile-returns'>Mobile Returns</option>
                                <option value='ringfenced-funds'>Ringfenced Funds</option>
                                <option value='statements'>Statements</option>
                                <option value='trading'>Trading</option>
                                <option value='card-expiration'>Card Expiration</option>
                                <option value='payments'>Payments</option>
                                <option value='winners-and-losers'>Lifetime Losers & Winners</option>
                                <option value='credit-debit'>Credit Debit</option>
                                <option value='incomeaccess-accounts'>IncomeAccess Accounts</option>
                                <option value='incomeaccess-sales'>IncomeAccess Sales</option>
                                <option value='affiliate-accounts'>Affiliate Accounts</option>
                                <option value='affiliate-sales'>Affiliate Sales</option>
                                <option value='void-bets'>Void Bet</option>
                                <option value='play-break'>People on player breaks</option>
                               
                            </select>
                        )
                    }

                    {
                        accountIdField
                    }
                    <div className='buttons'>
                        <a className='btn' href='#' onClick={ runReportButtonAction }>Run Report</a>
                        <button className='btn btn-primary' type='submit'>View Reports</button>
                    </div>
                </div>

                <Popup
                    title='Specify report parameters'
                    className='reports-filter-report-params-modal'
                    active={ this.state.displayReportParamsPopup }
                    closeButton={ true }
                    overlayClose={ true }
                    onClose={ this.hideReportParamsForm.bind(this)}
                >
                    {
                        paramsFields
                    }

                    <div className='buttons'>
                        <a className='btn' href='#' onClick={ this.onRunReport.bind(this)}>Run report</a>
                    </div>
                </Popup>

                <Popup
                    title='Report generated'
                    active={ this.props.state === 'FINISHED' }
                    overlayClose={ true }
                    closeButton={ false }
                    onClose={ this.onReload.bind(this)}
                >
                    Report has been successfully generated.

                    <div className='buttons'>
                        <a className='btn' href='#' onClick={ this.onReload.bind(this)}>Ok</a>
                    </div>
                </Popup>

                <Popup
                    title='Error occurred'
                    active={ this.props.state === 'ERROR' }
                    overlayClose={ true }
                    closeButton={ false }
                    onClose={ this.onReload.bind(this)}
                >
                    Report has not been generated.

                    <div className='buttons'>
                        <a className='btn' href='#' onClick={ this.onReload.bind(this)}>Ok</a>
                    </div>
                </Popup>

                <Loading
                    active={ this.props.state === 'IN_PROGRESS' }
                    message='Generating report...'
                />
            </div>
        );
    }
}

export default ReportsFilter;
